module.exports = __webpack_public_path__ + "static/amir-givati-climacell-1308026be76acbd3af1183e532618c93.png";